<div mat-dialog-content class="email-modal">
    <div class="email-modal__head">
        <div class="email-modal__title">{{ message }}</div>
        <button class="email-modal__close-btn" (click)="DialogRef.close(null)">
            <img
                src="./assets/icons/actions/close.svg"
                alt="Закрыть"
                [mat-dialog-close]="true"
            />
        </button>
    </div>

    <input
        class="email-modal__input"
        type="email"
        placeholder="{{ oldEmail || 'user@mail.ru' }}"
        [(ngModel)]="newEmail"
        [ngClass]="{ 'invalid-email': !isEmailValid() }"
    />

    <button
        class="email-modal__btn"
        [ngClass]="{
            'cls-btn-send-disable':
                !isEmailValid() ||
                (oldEmail &&
                    oldEmail.length !== 0 &&
                    newEmail.trim() === oldEmail),
        }"
        (click)="saveEmail()"
        [disabled]="
            !isEmailValid() ||
            (oldEmail && oldEmail.length !== 0 && newEmail.trim() === oldEmail)
        "
    >
        Подтвердить
    </button>
</div>
